import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { AVATAR_CATEGORY } from "common/viewContent";
import * as Path from "routes/Path/index";
import {
  getAvatarCategoryList, AddAvatarCategory,
  editAvatarCategory, deleteAvatarCategory
} from "store/actions";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import AddModal from "components/Modals/AddAvatarCategory";
import FormikForm from "components/shared/FormikForm";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search using name, type...",
  },
];
const initialValuesForFilter = {
  search: "",
  select: "",
};

const List = () => {
  const dispatch = useDispatch();
  const { avatarCategories, loading, totalAvatarCatgories } = useSelector((state) => state.Avatar);
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);

  const [filter, setFilter] = useState({
    pageNo: 1,
    limit: 20,
    order: -1,
    orderBy: "createdAt",
    search: "",
    status: ""
  });

  const [formData, setFormData] = useState({
    name: "",
    imageUrl: "",
    baseUrl: "",
  });

  const [addModalShow, setAddModalShow] = useState(false);

  const [editModalShow, setEditModalShow] = useState(false);

  useEffect(() => {
    getApiData(filter);
    setcolumns(Columns({ deleteHandler, handleEditHandler }));
  }, [filter]);

  async function getApiData(query) {
    try {
      dispatch(getAvatarCategoryList({ data: query, callback: null }));
    } catch (error) { }
  }

  const deleteHandler = (id) => {
    try {
      const userConfirmed = window.confirm("Are you sure, you want to delete this avatar category?");
      if (userConfirmed) {
        const callback = (err, res) => {
          if (err) {
            toast.error(err);
          } else {
            getApiData(filter);
            toast.success(res.message);
          }
        };

        dispatch(
          deleteAvatarCategory({
            data: { _id: id },
            callback,
          })
        );
      }
    } catch (error) {
      console.log(error, "<===err");
    }
  };

  const handleSubmit_ = (info) => {
    try {
      console.log(info, "info");
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          console.log(res);
          setAddModalShow(false);
          getApiData(filter);
          toast.success(res.message);
        }
      };
      dispatch(
        AddAvatarCategory({
          data: info,
          callback,
        })
      );
    }
    catch (error) {
      console.log(error, "<===err");
    }
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      pageNo: 1,
      limit: 20,
      order: -1,
      orderBy: "createdAt",
      search: info.search
    });
  };

  const handleEditHandler = (info) => {
    console.log({ ...formData, ...info });
    setFormData({ ...formData, ...info });
    setEditModalShow(true);
  };

  const handleEditSub = (info) => {
    try {
      console.log('info', info);
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setEditModalShow(false);
          getApiData(filter);
          toast.success(res.message);
          setFormData({})
        }
      };
      let data = {
        _id: info._id,
        name: info.name,
        imageUrl: info.imageUrl,
        baseUrl: info.baseUrl,
      }
      dispatch(
        editAvatarCategory({
          data: data,
          callback,
        })
      );
    } catch (error) {
      console.log(error, "<===err");
    }
  };

  return (
    <>
      <AddModal
        show={addModalShow}
        handleClose={() => {
          setAddModalShow(false);
        }}
        title={"Add Avatar Category"}
        content={""}
        handleConfirm={handleSubmit_}
        loading={loading}
        initialValues={formData}
      />

      <AddModal
        show={editModalShow}
        handleClose={() => {
          setEditModalShow(false);
        }}
        title={"Edit Avatar Category"}
        content={""}
        handleConfirm={handleEditSub}
        loading={loading}
        initialValues={formData}
      />
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={AVATAR_CATEGORY.CURRENT_MODULE} />

      <section className="section">
        <div className="section-header">
          <h1>{AVATAR_CATEGORY.CURRENT_MODULE}</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{AVATAR_CATEGORY.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{AVATAR_CATEGORY.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-6">
                <div className="card-header d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => setAddModalShow(true)}
                  >
                    Add Avatar Category
                  </button>
                </div>
              </div>
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                  />
                </div>
              </div>

            </div>
          </div>
          {avatarCategories?.length > 0 && (
            <Table
              data={avatarCategories}
              columns={columns}
              setFilter={setFilter}
              total={totalAvatarCatgories}
              filter={filter}
            />
          )}
          {!loading && avatarCategories?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Categories Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;